// @ts-nocheck
/* Port of PinnedHero.js (49L). BYTE-IDENTICAL. */
import React from 'react';
import VersionBadge from './VersionBadge';
import ReleaseTypeBadge from './ReleaseTypeBadge';
import TagChip from './TagChip';
import QuickSummaryChecklist from './QuickSummaryChecklist';
import { formatReleaseDate } from './releaseUtils';

const PinnedHero = ({ release, onOpen }: any) => {
  if (!release) return null;
  return (
    <div className="rc-pinned rc-fade-up">
      <span className="rc-pinned__flag">📌 Pinned Release</span>
      <div className="rc-card__meta" style={{ marginTop: 12 }}>
        <VersionBadge version={release.version} />
        <ReleaseTypeBadge type={release.release_type} />
        <span
          className="rc-modal__date"
          style={{ color: 'var(--rc-text-muted)' }}
        >
          {formatReleaseDate(release.release_date)}
        </span>
      </div>
      <h2 className="rc-pinned__title">{release.title}</h2>
      {release.summary && (
        <p className="rc-pinned__summary">{release.summary}</p>
      )}

      {release.highlights?.length > 0 && (
        <QuickSummaryChecklist highlights={release.highlights.slice(0, 6)} />
      )}

      {release.tags?.length > 0 && (
        <div className="rc-tags">
          {release.tags.map((t: any) => (
            <TagChip key={t.id} tag={t} />
          ))}
        </div>
      )}

      <div style={{ marginTop: 18 }}>
        <button
          type="button"
          className="rc-btn rc-btn--primary"
          onClick={() => onOpen(release)}
        >
          Read the full release →
        </button>
      </div>
    </div>
  );
};

export default PinnedHero;
